export default __webpack_public_path__ + "assets/f442b7e3211a6c8f2ab864d3b0212784.jpg";